import Logger from 'services/logger';
const componentConverter = components => {
  try {
    return components?.reduce(
      (accum, component) => ({
        ...component,
        title: component?.properties?.large || accum?.title,
      }),
      {},
    );
  } catch (error) {
    return { title: '' };
  }
};

export const transformCmsInfo = fetchedCarousels => {
  if (!fetchedCarousels) return [];
  let carousels = [];
  try {
    carousels = fetchedCarousels.map(carousel => {
      const { title } = componentConverter(carousel?.components?.component);
      return {
        component:
          carousel.components.component?.[0]?.type === 'Highlight'
            ? carousel?.components?.component?.[0]
            : carousel?.components?.component?.[
                carousel?.components?.component?.length - 1
              ],
        name: carousel?.name,
        type: carousel?.type,
        title,
      };
    });

    return carousels;
  } catch (error) {
    Logger.error(error);
    return [];
  }
};

export const transformCmsUserInfo = fetchedCarousels => {
  const carousels = fetchedCarousels?.map(carousel => {
    const { title } = componentConverter(carousel?.components?.component);

    return {
      component: carousel?.components?.component?.[0],
      name: carousel?.name,
      type: carousel?.type,
      title,
    };
  });
  return carousels;
};

export const getSlidePercentage = (isMobile = false) => {
  if (isMobile) return 82;

  const percentegeResult = ((771 / (window.innerWidth - 32)) * 100).toFixed(0);

   return percentegeResult > 100 ? 100 : percentegeResult;
};

export const debounceFunction = (cb, delay) => {
  let timer;
  return () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => cb(), delay);
  };
};
